module.exports = require("memoizee");


//////////////////
// WEBPACK FOOTER
// external "memoizee"
// module id = 476
// module chunks = 0